// What the battery is doing, from its power as reported: positive is discharging into the site,
// negative is charging, and zero is neither - it used to read as Charging.
export const batteryFlowLabel = (
  batteryPowerWatts?: number | null,
): string => {
  if (!batteryPowerWatts) {
    return "Standby";
  }

  return batteryPowerWatts > 0 ? "Discharging" : "Charging";
};
